import configGeneral from '../config_general.json';

export const useConfig = () => {
  return configGeneral;
};